var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploaddoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4750_40549)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 17,
    fill: "#1D5AB9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4750_40549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.75 23.0055C25.75 23.4121 25.4156 23.7392 25 23.7392C24.5844 23.7392 24.25 23.4121 24.25 23.0055V14.5038L21.2812 17.408C20.9875 17.6954 20.5125 17.6954 20.2219 17.408C19.9312 17.1206 19.9281 16.656 20.2219 16.3717L24.4688 12.2141C24.7625 11.9267 25.2375 11.9267 25.5281 12.2141L29.7812 16.3717C30.075 16.659 30.075 17.1237 29.7812 17.408C29.4875 17.6923 29.0125 17.6954 28.7219 17.408L25.7531 14.5038V23.0055H25.75ZM26.75 22.7609V21.2935H31C32.1031 21.2935 33 22.1709 33 23.2501V25.6957C33 26.7749 32.1031 27.6522 31 27.6522H19C17.8969 27.6522 17 26.7749 17 25.6957V23.2501C17 22.1709 17.8969 21.2935 19 21.2935H23.25V22.7609H19C18.725 22.7609 18.5 22.981 18.5 23.2501V25.6957C18.5 25.9647 18.725 26.1848 19 26.1848H31C31.275 26.1848 31.5 25.9647 31.5 25.6957V23.2501C31.5 22.981 31.275 22.7609 31 22.7609H26.75ZM29 24.4729C29 24.2783 29.079 24.0917 29.2197 23.9541C29.3603 23.8165 29.5511 23.7392 29.75 23.7392C29.9489 23.7392 30.1397 23.8165 30.2803 23.9541C30.421 24.0917 30.5 24.2783 30.5 24.4729C30.5 24.6675 30.421 24.8541 30.2803 24.9917C30.1397 25.1293 29.9489 25.2066 29.75 25.2066C29.5511 25.2066 29.3603 25.1293 29.2197 24.9917C29.079 24.8541 29 24.6675 29 24.4729Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4750_40549",
    x: 0.8,
    y: 2.38419e-7,
    width: 48.4,
    height: 48.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4750_40549"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4750_40549",
    result: "effect2_dropShadow_4750_40549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4750_40549",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4750_40549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15.6522,
    fill: "white",
    transform: "translate(15 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaddoc);
export default __webpack_public_path__ + "static/media/uploaddoc.03c3db69f4aa202a5744b644ca5911c8.svg";
export { ForwardRef as ReactComponent };